var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.visible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "categoryForm",
              attrs: {
                model: _vm.categoryForm,
                rules: _vm.formRules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分类名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入分类名称" },
                    model: {
                      value: _vm.categoryForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryForm, "name", $$v)
                      },
                      expression: "categoryForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "上级分类", prop: "pid" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.parentCategoryOptions,
                      props: _vm.cascaderProps,
                      placeholder: "请选择上级分类",
                      disabled: _vm.isParentSelectDisabled,
                      clearable: "",
                      "show-all-levels": true,
                      filterable: "",
                      "filter-method": _vm.filterCategories,
                      "before-expand": _vm.beforeExpand,
                    },
                    on: { change: _vm.handleCategoryChange },
                    model: {
                      value: _vm.categoryForm.pid,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryForm, "pid", $$v)
                      },
                      expression: "categoryForm.pid",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "cascader-tip" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _vm._v(
                      "\n          分类最多支持三层，第三层分类不可再添加子分类\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分类图标(180*180)", prop: "extra" } },
                [
                  _c("div", { staticClass: "category-icon-upload-container" }, [
                    _vm.categoryForm.extra
                      ? _c("div", { staticClass: "icon-preview" }, [
                          _c("img", {
                            staticClass: "category-icon",
                            attrs: { src: _vm.categoryForm.extra },
                            on: { click: _vm.previewIcon },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "icon-overlay" }, [
                            _c("i", {
                              staticClass: "el-icon-view",
                              attrs: { title: "预览" },
                              on: { click: _vm.previewIcon },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "el-icon-delete",
                              attrs: { title: "删除" },
                              on: { click: _vm.removeIcon },
                            }),
                          ]),
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "icon-upload-placeholder",
                            on: { click: _vm.handleIconUpload },
                          },
                          [
                            _c("i", { staticClass: "el-icon-camera" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "upload-text" }, [
                              _vm._v("上传图标"),
                            ]),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "建议上传180*180像素的图片，支持jpg/png格式，大小不超过2MB"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { min: 0, max: 9999, "controls-position": "right" },
                    model: {
                      value: _vm.categoryForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryForm, "sort", $$v)
                      },
                      expression: "categoryForm.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": true,
                      "inactive-value": false,
                      "active-text": "启用",
                      "inactive-text": "禁用",
                    },
                    model: {
                      value: _vm.categoryForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryForm, "status", $$v)
                      },
                      expression: "categoryForm.status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imagePreviewVisible,
            title: "图片预览",
            width: "60%",
            center: "",
            "close-on-click-modal": true,
            "close-on-press-escape": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.imagePreviewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "image-preview-container" }, [
            _c("img", {
              staticClass: "preview-image",
              attrs: { src: _vm.currentPreviewImage, alt: "预览图片" },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }